import { Fab, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material'
import { Add, Forum, GroupAdd } from '@mui/icons-material'
import { PrayerIcon } from './PrayerIcon'


interface QuickActionsProps {
  onNewPrayer: () => void
  onNewDiscussion: () => void
  onNewGroup?: () => void
  /** When set to 'prayers' or 'discussions', the button directly invokes the corresponding action instead of showing a speed dial. */
  activeContext?: 'prayers' | 'discussions'
}

export default function QuickActions({ onNewPrayer, onNewDiscussion, onNewGroup, activeContext }: QuickActionsProps) {
  if (activeContext === 'prayers') {
    return (
      <Fab
        color="primary"
        aria-label="New Prayer Request"
        sx={{ position: 'fixed', bottom: 72, right: 16 }}
        onClick={onNewPrayer}
      >
        <Add />
      </Fab>
    )
  }

  if (activeContext === 'discussions') {
    return (
      <Fab
        color="primary"
        aria-label="New Discussion"
        sx={{ position: 'fixed', bottom: 72, right: 16 }}
        onClick={onNewDiscussion}
      >
        <Add />
      </Fab>
    )
  }

  return (
    <SpeedDial
      ariaLabel="Quick actions"
      sx={{ position: 'fixed', bottom: 72, right: 16 }}
      icon={<SpeedDialIcon />}
    >
      <SpeedDialAction
        key="prayer"
        icon={<PrayerIcon />}
        slotProps={{ tooltip: { title: 'New Prayer Request' } }}
        onClick={onNewPrayer}
      />
      <SpeedDialAction
        key="discussion"
        icon={<Forum />}
        slotProps={{ tooltip: { title: 'New Discussion' } }}
        onClick={onNewDiscussion}
      />
      {onNewGroup && (
        <SpeedDialAction
          key="create-group"
          icon={<GroupAdd />}
          slotProps={{ tooltip: { title: 'New Group' } }}
          onClick={onNewGroup}
        />
      )}
    </SpeedDial>
  )
}
